import { get, reduce, noop } from 'lodash';
import { Tooltip } from 'element-ui';
import { Icon } from 'patsnap-biz';
import LegalTag from 'library-@/components/legal-tag/legal-tag';
import { POPPER_OPEN_DELAY } from '../../constants';
import abstMf from '../../subview_plugins/Abst/manifest';
import litigationMf from '../../subview_plugins/Litigation/manifest';
import licensingMf from '../../subview_plugins/Licensing/manifest';
import { getCurrentLanguage } from 'library-@/utils/getCurrentLanguage';
import '@patsnap-ui/icon/assets/solid/litigation.svg';
import '@patsnap-ui/icon/assets/solid/licence.svg';
import '@patsnap-ui/icon/assets/solid/s.svg';

// 这个给模版做参考，对照着改
const LEGAL_MAPS = Object.preventExtensions([
    {
        id: 0,
        name: 'LITIGATION',
        icon: 'SolidLitigation',
        path: litigationMf.exclusiveRoutePath,
        text: 'litigation'
    },
    {
        id: 1,
        name: 'LICENSE',
        icon: 'SolidLicence',
        path: licensingMf.exclusiveRoutePath,
        text: 'licensing'
    },
    {
        id: 2,
        name: 'STANDARD',
        icon: 'SolidS',
        path: abstMf.exclusiveRoutePath,
        text: 'SEP'
    }
]);

export default {
    name: 'Legals',
    components: {
        LegalTag,
        ElTooltip: Tooltip,
        PtIcon: Icon
    },
    props: {
        legalObject: {
            type: Object,
            default() {
                return {
                    HAS_LICENSE: false,
                    HAS_LITIGATION: false,
                    HAS_STANDARD: false
                };
            }
        },
        legalStatus: {
            type: Array,
            default() {
                return [];
            }
        },
        openType: {
            default: '_blank'
        },
        clickCallBack: {
            type: Function,
            default() {
                return noop;
            }
        },
        showText: {
            type: Boolean,
            default: false
        },
        callbackParams: {
            type: Object,
            default() {
                return {};
            }
        },
        withoutPatentList: {
            type: Boolean,
            default: true
        },
        isSimple: {
            type: Boolean,
            default: false
        },
        modeType: {
            type: String,
            default: 'default',
        },
    },
    created() {
        this.popperOpenDelay = POPPER_OPEN_DELAY;
    },
    data() {
        return {
            currentLang: getCurrentLanguage()
        };
    },
    computed: {
        legalMaps() {
            return reduce(
                LEGAL_MAPS,
                (array, legal) => {
                    const { name } = legal;
                    if (this.legalObject[`HAS_${name}`]) {
                        legal.label = this.$t(`patent-view.${legal.text}`);
                        legal.url = this.makeUrl(legal);
                        return array.concat(legal);
                    }
                    return array;
                },
                []
            );
        }
    },
    methods: {
        makeUrl(item) {
            const targetPatentId = get(this, 'callbackParams.params.patentId');

            if (targetPatentId) {
                const path = item.path;
                const params = { ...this.$route.params };
                const query = { ...this.$route.query, patentId: targetPatentId };

                // 如果不需要patent-list 删除以下几个参数即可
                if (this.withoutPatentList) {
                    delete query.sort;
                    delete query.rows;
                    delete query.page;
                    delete query.compare_id;
                }

                const routeData = this.$router.resolve({ path, params, query });
                return routeData.href;
            }
            return '';
        },
        clickCall(target, event) {
            this.clickCallBack(target, this.callbackParams, event);
        }
    }
};
